/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            marginY: '15px',
            marginX: {base: '15px', lg: '60px'},
            sx: {
                span: {
                    color: 'gray.800',
                    textStyle: 'small',
                    marginX: '5px',
                    fontSize: {base: '12px', lg: '14px'},
                    lineHeight: '22px',
                    letterSpacing: {base: '0.06px', lg: '0.07px'},
                    fontWeight: '300'
                }
            }
        },
        icon: {
            display: 'flex',
            boxSize: 4
        },
        link: {
            textStyle: 'small',
            color: 'gray.800',
            padding: '0',
            textDecoration: 'none',
            _hover: {
                color: 'black.100'
            },
            fontSize: {base: '12px', lg: '14px'},
            lineHeight: '22px',
            letterSpacing: {base: '0.06px', lg: '0.07px'},
            fontWeight: '300'
        }
    },
    parts: ['container', 'icon', 'link']
}
